// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4f73361d","239":"f250dada","453":"ff6ba52c","732":"6182852e"}[chunkId] + ".chunk.js";
};